
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-button-child');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      console.log("aaaa");
      const targetUl = this.nextElementSibling;

      if (targetUl && targetUl.tagName === 'UL') {
        targetUl.classList.toggle('is-open');
        this.classList.toggle('is-open');

        if (targetUl.classList.contains('is-open')) {
        } else {
        }
      }
    });
  });
});

// カート情報を取得して更新する関数
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElement = document.querySelector('.header__cart-dot-custom');
      if (cartCountElement) {
        cartCountElement.textContent = cart.item_count; // または cart.item_count
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

document.addEventListener('DOMContentLoaded', updateCartCount);

document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".sp_cart_btn, .favoorite_btn");
  const variationCart = document.querySelector(".variation_cart");
  const cartCloseBtn = document.querySelector(".variation_cart_close_btn");
  const closeBtn = document.querySelector(".variation_cart_close_innner_btn");
  const header = document.querySelector(".header__outer-wrapper");
  const body = document.querySelector("body");

    cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.add("active");
        variationCart.classList.remove("fade-out-down");
        cartCloseBtn.classList.add("active");
        cartCloseBtn.classList.remove("fade-out-down");
        header.classList.add("hidden");
        body.classList.add("pop");
      }
    });
  });

  function closeModal() {
    if (variationCart) {
      variationCart.classList.remove("active");
      variationCart.classList.add("fade-out-down");
      cartCloseBtn.classList.remove("active");
      cartCloseBtn.classList.add("fade-out-down");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener("click", closeModal);
  }
  /*

  cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.add("active");
        cartCloseBtn.classList.add("active");
        header.classList.add("hidden");
        body.classList.add("pop");
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.remove("active");
        cartCloseBtn.classList.remove("active");
        header.classList.remove("hidden");
        body.classList.remove("pop");
      }
    });
  }

  cartCloseBtn.addEventListener("click", function () {
    if (variationCart) {
      variationCart.classList.remove("active");
      cartCloseBtn.classList.remove("active");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  });

*/

});




document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.sp_button');
  const fixedBtn = document.querySelector('.sp_cart_btn_fixed');

  let isBelowTarget = false;

  if (!target || !fixedBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isBelowTarget = false;
        fixedBtn.classList.remove('active');
      } else {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > targetPosition) {
          isBelowTarget = true;
          fixedBtn.classList.add('active');
        }
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(target);
});


document.addEventListener("DOMContentLoaded", function () {
  // .variation_cart内の.variant-blockにクリックイベントを追加
  const variationCart = document.querySelector('.variation_cart');
  if (variationCart) {
    const variantBlocks = variationCart.querySelectorAll('.variant-block');
    
    variantBlocks.forEach(block => {
      block.addEventListener('click', function() {
        try {
          // クリックされた要素のdata-color値を取得
          const colorValue = this.getAttribute('data-color');
          
          if (colorValue) {
            // .variant-picker__option要素の存在確認
            const variantPickerOption = document.querySelector('.variant-picker__option');
            
            if (variantPickerOption) {
              // 一致するdata-valueを持つ.thumbnail-swatchを探す
              const matchingSwatch = variantPickerOption.querySelector(
                '.thumbnail-swatch[data-value="' + colorValue + '"]'
              );
              
              if (matchingSwatch) {
                // 現在のスクロール位置を保存
                const currentScrollX = window.scrollX;
                const currentScrollY = window.scrollY;
                
                // 一致する要素を疑似的にクリック
                matchingSwatch.click();
                
                // スクロール位置を元に戻す
                window.scrollTo(currentScrollX, currentScrollY);
              }
            }
          }
        } catch (error) {
          // エラーが発生した場合はコンソールに出力（本番環境では削除可能）
          console.warn('variant-block click handler error:', error);
        }
      });
    });
  }
});


// DOMContentLoaded waits for both custom.js (module) and the deferred CDN Swiper.
// Prepare product cards near the viewport, or synchronously on the first interaction.
document.addEventListener('DOMContentLoaded', function() {
  const registered = new Set();
  const selector = '.hover-slider';
  const viewportObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) initializeSwiper(entry.target);
        });
      }, { rootMargin: `${window.innerHeight}px 0px` })
    : null;

  function initializeSwiper(container) {
    if (!container.isConnected || typeof Swiper === 'undefined') return;
    if (container.swiperInstance) return container.swiperInstance;
    if (!container.querySelector('.swiper-slide')) return;

    const instance = new Swiper(container, {
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: container.querySelector('.button-next'),
        prevEl: container.querySelector('.button-prev'),
      },
      autoplay: false,
      nested: true,
      autoHeight: true,
      observer: true,
      observeParents: true,
    });
    container.swiperInstance = instance;
    // A click can arrive while deferred scripts are still loading.
    if (container.dataset.pendingSlide) {
      instance.slideTo(Math.max(0, Number(container.dataset.pendingSlide)), 0);
      delete container.dataset.pendingSlide;
    }
    viewportObserver?.unobserve(container);
    return instance;
  }

  function register(container) {
    if (registered.has(container) || !container.isConnected) return;
    registered.add(container);
    if (container.dataset.pendingSlide) initializeSwiper(container);
    else if (viewportObserver) viewportObserver.observe(container);
    else initializeSwiper(container);
  }

  function release(container) {
    viewportObserver?.unobserve(container);
    container.swiperInstance?.destroy(true, true);
    delete container.swiperInstance;
    registered.delete(container);
  }

  function forEachSlider(root, callback) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  // Capture runs before Swiper's target handlers, preserving the first gesture/click.
  function prepareInteraction(event) {
    const container = event.target.closest?.(selector);
    if (container) initializeSwiper(container);
  }
  document.addEventListener('pointerover', prepareInteraction, { capture: true, passive: true });
  document.addEventListener('pointerdown', prepareInteraction, { capture: true, passive: true });
  document.addEventListener('touchstart', prepareInteraction, { capture: true, passive: true });
  document.addEventListener('focusin', prepareInteraction, true);
  document.addEventListener('click', prepareInteraction, true);

  // Delegate swatches so cards added by filters, recommendations and the editor work too.
  document.addEventListener('click', function(event) {
    const swatch = event.target.closest?.('.product-swatches-options__item--swatch');
    if (!swatch) return;
    const container = swatch.closest('.product-item')?.querySelector(selector);
    const imageUrl = swatch.dataset.variantImageUrl;
    if (!container || !imageUrl) return;
    event.preventDefault();
    const instance = initializeSwiper(container);
    const slide = instance ? instance.slides[instance.activeIndex] : container.querySelector('.swiper-slide');
    const image = slide?.querySelector('img');
    if (image) {
      image.src = imageUrl;
      image.srcset = imageUrl;
    }
  });

  forEachSlider(document.body, register);
  const mutationObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.removedNodes.forEach(node => forEachSlider(node, container => {
        if (!container.isConnected) release(container);
      }));
      mutation.addedNodes.forEach(node => forEachSlider(node, register));
    }
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => forEachSlider(event.target, release));
  document.addEventListener('shopify:section:load', event => forEachSlider(event.target, register));
});

// ===== PC商品メイン画像スライダー (A案) =====
// theme.js のモバイルカルーセルは 960px 未満専用のため、ここでは 960px 以上でのみ
// 独立した Swiper を初期化する（グローバル Swiper = CDN swiper@9 を利用）。
(function () {
  var DESKTOP_MQ = '(min-width: 960px)';

  // バリアントID -> 代表画像ID のマップ。セクションが埋め込む
  // #ProductJson-<section id> を流用するので追加のLiquid出力は不要。
  function buildVariantMediaMap(sectionId) {
    var map = {};
    var node = document.getElementById('ProductJson-' + sectionId);
    if (!node) return map;
    try {
      var variants = JSON.parse(node.textContent).variants || [];
      variants.forEach(function (variant) {
        if (variant.featured_media) map[variant.id] = variant.featured_media.id;
      });
    } catch (e) {
      /* JSONが壊れていても他機能を止めない */
    }
    return map;
  }

  // theme.js はカラー切替時、PC側では対象画像に scrollIntoView をかける
  // (assets/theme.js の _updateVariant 内)。Swiper は transform でスライドを
  // 動かすため scrollIntoView では追従しないので、明示的に slideTo する。
  function syncToSelectedVariant(el) {
    if (!el.pcSwiper || !el.variantSelect || !el.variantMediaMap) return;

    var mediaId = el.variantMediaMap[el.variantSelect.value];
    if (!mediaId) return;

    var slide = el.querySelector('[data-media-item-id="' + mediaId + '"]');
    if (!slide) return;

    var index = Array.prototype.indexOf.call(slide.parentElement.children, slide);
    if (index >= 0 && index !== el.pcSwiper.activeIndex) el.pcSwiper.slideTo(index);
  }

  function bindVariantSync(el) {
    if (el.variantSyncBound) return;

    var section = el.closest('[data-section-id]');
    if (!section) return;

    var select = section.querySelector('select[data-variant-select]');
    var form = select && select.closest('form');
    if (!form) return;

    el.variantSelect = select;
    el.variantMediaMap = buildVariantMediaMap(section.dataset.sectionId);

    // theme.js はフォームに new Event('change') を投げるが、これは bubbles:false
    // なので document への委譲では拾えない。フォーム自身に張る必要がある。
    form.addEventListener('change', function () {
      // theme.js が select の選択状態を更新し終えた直後に走らせる
      setTimeout(function () {
        syncToSelectedVariant(el);
      }, 0);
    });

    el.variantSyncBound = true;
  }

  function initPcProductCarousel() {
    var carousels = document.querySelectorAll('.pc-product-carousel[data-pc-carousel]');
    if (!carousels.length || typeof Swiper === 'undefined') return;

    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;

    carousels.forEach(function (el) {
      // 画像が1枚だけの商品では矢印とドットを出さない（CSS側で制御）
      el.classList.toggle(
        'pc-product-carousel--single',
        el.querySelectorAll('.swiper-slide').length <= 1
      );

      // モバイル幅ではPCスライダーを破棄（theme.js側のモバイルカルーセルに委ねる）
      if (!isDesktop) {
        if (el.pcSwiper) {
          el.pcSwiper.destroy(true, true);
          el.pcSwiper = null;
        }
        return;
      }

      if (el.pcSwiper) return; // 初期化済み

      el.pcSwiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 8,
        grabCursor: true,
        autoHeight: true,
        navigation: {
          nextEl: el.querySelector('.pc-product-carousel__next'),
          prevEl: el.querySelector('.pc-product-carousel__prev')
        },
        pagination: {
          el: el.querySelector('.pc-product-carousel__pagination'),
          clickable: true,
          // 画像が数十枚ある商品ではドットが横に並びきらず2段に折り返してしまう。
          // dynamicBullets で常に数個だけ表示する。
          dynamicBullets: true,
          dynamicMainBullets: 3
        }
      });

      bindVariantSync(el);

      // 初期表示でスライドを動かすのは、URLでバリアントが明示されている場合だけ。
      // 無条件に動かすと、どのバリアントにも紐づかない先頭のイメージカット
      // (商品ごとに意図して1枚目に置かれている)を飛ばしてしまう。
      if (new URLSearchParams(location.search).has('variant')) {
        syncToSelectedVariant(el);
      }
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initPcProductCarousel, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPcProductCarousel);
  } else {
    initPcProductCarousel();
  }
  window.addEventListener('resize', onResize);
})();


// ===== PCでギャラリーを画面に追従させる（画像下の空白対策）=====
// 商品ページは2カラムグリッドで、行の高さは背の高いほうのカラムで決まる。
// 一覧表示のときは左(全画像を縦に積む)が高かったが、1枚ずつのスライドにした
// ことで右(説明文)が高くなり、画像の下に大きな空白が出るようになった。
// ギャラリーを sticky にして、その空白を追従表示で埋める。
//
// 画像は縦長(2:3)で画面より高いため top:0 だと上端で貼り付き、下端が永久に
// 見えなくなる。「下端が画面下に来たら止まる」よう負の top を算出する。
(function () {
  var DESKTOP_MQ = '(min-width: 960px)';
  var GALLERY = '.product__media-container.above-mobile[data-gallery-style="carousel"]';
  var BOTTOM_GAP = 16;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-desktop-sticky-height');
    return parseFloat(raw) || 0;
  }

  function update(gallery) {
    if (!window.matchMedia(DESKTOP_MQ).matches) {
      gallery.style.removeProperty('--pc-gallery-sticky-top');
      return;
    }

    var offset = headerOffset();
    var overflow = gallery.offsetHeight - (window.innerHeight - offset) + BOTTOM_GAP;

    // 画面に収まる高さなら通常どおりヘッダー直下で貼り付ける
    gallery.style.setProperty(
      '--pc-gallery-sticky-top',
      overflow > 0 ? -overflow + 'px' : offset + 'px'
    );
  }

  function init() {
    var gallery = document.querySelector(GALLERY);
    if (!gallery) return;

    function recalc() {
      update(gallery);
    }

    recalc();

    // ギャラリーの高さは Swiper の autoHeight とサムネイル画像の遅延読み込みで
    // あとから変わる。取りこぼすと古い値のまま貼り付いてしまうため、
    // ResizeObserver だけに頼らず複数の契機で計算し直す。
    if (window.ResizeObserver) {
      // インスタンスを変数に持たないとGCされうるので要素に保持させる
      gallery.pcGalleryObserver = new ResizeObserver(recalc);
      gallery.pcGalleryObserver.observe(gallery);
    }

    // サムネイルは loading="lazy" なので読み込み完了のたびに高さが伸びる。
    // load はバブルしないのでキャプチャで拾う。
    gallery.addEventListener('load', recalc, true);
    window.addEventListener('load', recalc);

    // 上記をすべて取りこぼした場合の保険
    [300, 1000, 2500].forEach(function (delay) {
      setTimeout(recalc, delay);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalc, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ===== カルーセルのサムネイル列 =====
// ドットの代わりに写真一覧を出し、スライダーと双方向に同期させる。
// テーマ純正のサムネイル(theme.js が [data-product-thumbnail] のクリックを拾って
// _switchCurrentImage() を呼ぶ)とは別の data 属性を使っているため、
// theme.js 側の処理は一切走らず、カルーセルが壊れることがない。
(function () {
  var ROOTS = {
    pc: '.pc-product-carousel[data-pc-carousel]',
    mobile: '.product__media-container.below-mobile.carousel.swiper'
  };

  // PCは custom.js、モバイルは theme.js が Swiper を生成する。どちらも Swiper が
  // element.swiper を生やすので、インスタンスは保持せず都度引く。
  // theme.js はブレークポイントを跨ぐと destroy して作り直すため。
  function getSwiper(context) {
    var root = document.querySelector(ROOTS[context]);
    if (!root || !root.swiper || root.swiper.destroyed) return null;
    return root.swiper;
  }

  function getThumbs(context) {
    return document.querySelector('[data-carousel-thumbs="' + context + '"]');
  }

  // scrollIntoView はページ側まで動かしうるので scrollLeft を直接操作する
  function keepThumbVisible(list, button) {
    var left = button.offsetLeft;
    var right = left + button.offsetWidth;

    if (left < list.scrollLeft) {
      list.scrollLeft = left - 8;
    } else if (right > list.scrollLeft + list.clientWidth) {
      list.scrollLeft = right - list.clientWidth + 8;
    }
  }

  function syncActiveThumb(context) {
    var swiper = getSwiper(context);
    var thumbs = getThumbs(context);
    if (!swiper || !thumbs) return;

    var activeSlide = swiper.slides[swiper.activeIndex];
    var activeId = activeSlide && activeSlide.dataset.mediaItemId;
    var list = thumbs.querySelector('.carousel-thumbs__items');

    thumbs.querySelectorAll('[data-carousel-thumb]').forEach(function (button) {
      var isActive = button.dataset.mediaItemId === activeId;
      button.classList.toggle('is-active', isActive);
      if (isActive && list) keepThumbVisible(list, button);
    });
  }

  function slideToMedia(context, mediaId) {
    var swiper = getSwiper(context);
    if (!swiper) return;

    var slides = swiper.slides || [];
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaItemId !== mediaId) continue;

      if (swiper.params.loop) {
        // loop 有効時は複製スライドが混ざるので実インデックスで指定する
        var realIndex = parseInt(slides[i].dataset.swiperSlideIndex, 10);
        swiper.slideToLoop(isNaN(realIndex) ? i : realIndex);
      } else {
        swiper.slideTo(i);
      }
      return;
    }
  }

  function bindThumbClicks(context) {
    var thumbs = getThumbs(context);
    if (!thumbs || thumbs.dataset.clicksBound) return;

    thumbs.addEventListener('click', function (event) {
      var button = event.target.closest('[data-carousel-thumb]');
      if (button) slideToMedia(context, button.dataset.mediaItemId);
    });

    thumbs.dataset.clicksBound = 'true';
  }

  function bindSwiper(context) {
    var swiper = getSwiper(context);
    if (!swiper || swiper.carouselThumbsBound) return;

    swiper.carouselThumbsBound = true;
    swiper.on('slideChange', function () {
      syncActiveThumb(context);
    });
    syncActiveThumb(context);
  }

  function tick() {
    ['pc', 'mobile'].forEach(function (context) {
      bindThumbClicks(context);
      bindSwiper(context);
    });
  }

  function init() {
    if (!getThumbs('pc') && !getThumbs('mobile')) return; // 商品ページ以外では何もしない

    tick();

    // theme.js の Swiper 生成は非同期なので、しばらく再試行する
    var attempts = 0;
    var timer = setInterval(function () {
      tick();
      if (++attempts >= 20) clearInterval(timer);
    }, 500);

    // ブレークポイントを跨ぐと Swiper が作り直されるため張り直す
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(tick, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ===== 写真に重ねるモデル情報の帯(MODEL / SIZE、カラーサムネではCOLORも) =====
// 表示中の写真がカラーサムネ(バリアントの代表画像)ならその写真のカラーの値を、
// それ以外の写真では選択中バリアントの MODEL / SIZE だけを出す。判定は
// data-band-media の完全一致のみで、間の写真をカラーで補完はしない
// (理由は snippets/model-info-band.liquid のコメント参照)。
//
// カラー切替にも追従させる。theme.js は select[data-variant-select] の選択を
// 更新してからフォームに change を投げるが、new Event('change') は
// bubbles:false なので document への委譲では拾えない。フォーム自身に張る。
(function () {
  function bands() {
    return document.querySelectorAll('[data-model-info-band]');
  }

  function readData(band) {
    if (!band.bandData) {
      try {
        band.bandData = {
          variants: JSON.parse(band.dataset.bandVariants || '{}'),
          media: JSON.parse(band.dataset.bandMedia || '{}')
        };
      } catch (e) {
        band.bandData = null; // JSONが壊れていても帯を消さず現状維持にする
      }
    }
    return band.bandData;
  }

  // PCは custom.js、モバイルは theme.js が Swiper を生成する。ブレークポイントを
  // 跨ぐと作り直されるのでインスタンスは保持せず都度引く。
  function activeMediaId(band) {
    var root = band.closest('.swiper');
    if (!root || !root.swiper || root.swiper.destroyed) return null;

    // loop 有効時は複製スライドが混ざるが、複製も data-media-item-id を持つので
    // 実インデックスの計算は不要。
    var slide = root.swiper.slides[root.swiper.activeIndex];
    return (slide && slide.dataset.mediaItemId) || null;
  }

  function render(band) {
    var data = readData(band);
    if (!data) return;

    var mediaId = activeMediaId(band);
    var colorVariantId = mediaId ? data.media[mediaId] : null;

    var info;
    if (colorVariantId) {
      info = data.variants[colorVariantId];
    } else {
      var scope = band.closest('[data-section-id]') || document;
      var select = scope.querySelector('select[data-variant-select]');
      info = select ? data.variants[select.value] : null;
    }

    // SIZE はモデルの着用サイズ。どちらも無いならカラー名だけの帯になるので出さない。
    if (!info || (!info.h && !info.s)) {
      band.hidden = true;
      return;
    }

    var parts = [];
    if (info.h) parts.push('MODEL : ' + info.h);
    if (colorVariantId && info.c) parts.push('COLOR : ' + info.c);
    if (info.s) parts.push('SIZE : ' + info.s);

    // 再試行タイマーから何度も呼ばれるので、変化が無ければDOMを触らない
    var next = parts.join('\n');
    if (band.bandText !== next) {
      band.bandText = next;
      band.textContent = '';
      parts.forEach(function (text) {
        var span = document.createElement('span');
        span.className = 'model-info-band__part';
        span.textContent = text;
        band.appendChild(span);
      });
    }
    band.hidden = false;
  }

  function bindSwiper(band) {
    var root = band.closest('.swiper');
    var swiper = root && root.swiper;
    if (swiper && !swiper.destroyed && !swiper.modelInfoBandBound) {
      swiper.modelInfoBandBound = true;
      swiper.on('slideChange', function () {
        render(band);
      });
    }
    render(band);
  }

  function bindForms() {
    document.querySelectorAll('select[data-variant-select]').forEach(function (select) {
      var form = select.closest('form');
      if (!form || form.modelInfoBandBound) return;

      form.modelInfoBandBound = true;
      form.addEventListener('change', function () {
        // theme.js が select の選択状態を更新し終えた直後に走らせる。
        // このあとスライドも動くので slideChange 側で再度上書きされる。
        setTimeout(function () {
          bands().forEach(render);
        }, 0);
      });
    });
  }

  function tick() {
    bindForms();
    bands().forEach(bindSwiper);
  }

  function init() {
    if (!bands().length) return; // 商品ページ以外・未入力商品では何もしない

    tick();

    // theme.js の Swiper 生成は非同期なので、しばらく再試行する
    var attempts = 0;
    var timer = setInterval(function () {
      tick();
      if (++attempts >= 20) clearInterval(timer);
    }, 500);

    // ブレークポイントを跨ぐと Swiper が作り直されるため張り直す
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(tick, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// アプリ流入時のヘッダー出し分けの判定は layout/theme.liquid の
// <head> 先頭に移設済み(ヘッダーのCSSペイント前に同期実行する必要があるため)。
